import { useUchiStore } from "@/stores/uchi";
import { useTilesStore } from "@/stores/tiles";
import { i18n } from "@/helpers/utilities/I18nHelper";

export const driveItemsHierarchy_state = {
  driveRootMap: {} // driveId: { itemId: { array of driveId,itemId in hierarchy }}
};

export const driveItemsHierarchy_actions = {
  async calculateDriveItemsHierarchy(driveId, itemId) {
    if (!this.driveRootMap[driveId] || !this.driveRootMap[driveId][itemId]) {
      await this.loadSharedDrives();
      await this.loadControlledAreaDefinitions();
      //  sectionfolders?
      // Load uchifolders?

      const hierarchyAbove = await this.loadParentDriveItemAndHierarchyAbove(driveId, itemId);

      if (hierarchyAbove.length > 1) {
        const nctMetaProperties = {
          nctSystem: hierarchyAbove[0].nctSystem,
          nctType: hierarchyAbove[0].nctType,
          nctGroup: hierarchyAbove[0].nctGroup,
          nctIdentifier: hierarchyAbove[0].nctIdentifier,
          nctBehaviour: hierarchyAbove[0].nctBehaviour
        };
        hierarchyAbove.forEach(c => this.setNCTMetaOnStoreDriveItems(c.driveId, c.itemId, nctMetaProperties));
      }

      if (!this.driveRootMap[driveId]) {
        this.driveRootMap[driveId] = {};
      }
      this.driveRootMap[driveId][itemId] = hierarchyAbove;
    }

    return this.driveRootMap[driveId][itemId];
  },

  /**
   * Load the driveItem hierarchy abode driveitem until root - should not be used outside store
   * @param { string } driveId DriveId to start hierarchy from
   * @param { string } itemId ItemId to start hierarchy from
   * @returns {Promise<Array<object>>} Array of hierarchy from driveItem and above
   */
  async loadParentDriveItemAndHierarchyAbove(driveId, itemId) {
    if (!driveId || !itemId) {
      return [];
    }
    const driveItem = await this.loadDriveItemWithoutDecorationgWithNCTProps(driveId, itemId);

    // Check if this is a combidrive root
    const combi = this.controlledAreaFromDriveIdAndItemId(driveItem.parentReference.driveId, driveItem.id);

    if (combi) {
      return [
        {
          driveId: driveItem.parentReference.driveId,
          itemId: driveItem.id,
          nctSystem: combi.system,
          nctGroup: combi.group,
          nctType: combi.type,
          nctIdentifier: combi.identifier,
          nctBehavior: combi.behavior
        }
      ];
    }

    // Check if this is a uchi defined folder as it then is the root
    const uchiStore = useUchiStore();
    const uchiSharePointTopFolder = uchiStore.getDriveItemId(driveItem.parentReference.driveId, driveItem.id);
    if (uchiSharePointTopFolder) {
      return [
        {
          name: uchiSharePointTopFolder.title,
          driveId: driveItem.parentReference.driveId,
          itemId: driveItem.id,
          nctSystem: "uchi",
          nctGroup: "uchi",
          nctType: "uchi",
          nctIdentifier: "uchi",
          nctBehavior: "uchi"
        }
      ];
    }

    // Check if this is a appSharePointFolder as it then is the root
    const sharePointTopFolder = this.sharedDrives.find(
      spf => spf.driveId === driveItem.parentReference.driveId && spf.itemId === driveItem.id
    );
    if (sharePointTopFolder) {
      return [
        {
          name: sharePointTopFolder.displayName,
          driveId: driveItem.parentReference.driveId,
          itemId: driveItem.id
        }
      ];
    }

    const tilesStore = useTilesStore();
    await tilesStore.loadTiles();
    const tileWithRoot = tilesStore
      .tiles()
      .find(tile => tile.uri?.uri?.includes(`${driveItem.parentReference.driveId}/${driveItem.id}`));
    if (tileWithRoot) {
      return [
        {
          driveId: driveItem.parentReference.driveId,
          itemId: driveItem.id,
          name: i18n.te(tileWithRoot.title) ? i18n.t(tileWithRoot.title) : tileWithRoot.title
        }
      ];
    }

    const hierarchyAbove = await this.loadParentDriveItemAndHierarchyAbove(driveId, driveItem.parentReference.id);
    hierarchyAbove.push({
      name: driveItem.name,
      driveId: driveItem.parentReference.driveId,
      itemId: driveItem.id,
      nctSystem: driveItem.system,
      nctGroup: driveItem.group,
      nctType: driveItem.type,
      nctIdentifier: driveItem.identifier,
      nctBehavior: driveItem.behavior
    });

    return hierarchyAbove;
  },

  async calculateDriveItemsRoot(driveId, itemId) {
    const hierarchy = await this.calculateDriveItemsHierarchy(driveId, itemId);
    if (hierarchy.length === 0) {
      return null;
    }
    return hierarchy[0];
  }
};

export const driveItemsHierarchy_getters = {};
